export default __webpack_public_path__ + "static/media/airline_miles_dark.738bef72.png";